const pendingRequests = new Map();

export const loadData = async (tagName, type) => {
    try {
        const response = await fetch(`https://res.cloudinary.com/dlkzchunj/${type || 'image'}/list/${tagName}.json`);
        if (!response.ok) {
            throw new Error(`Failed to fetch data for ${tagName}: ${response.statusText}`);
        }
        const data = await response.json();
        return data.resources;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const sortByOrderMetaData = (a, b) => b?.context?.custom?.order - a?.context?.custom?.order

export const loadDataWithCache = async (tagName, cache, setCache, type) => {
    const cacheKey = type ? `${tagName}_${type}` : tagName;
    if (cache[cacheKey]) {
        return cache[cacheKey];
    }

    if (!pendingRequests.has(cacheKey)) {
        pendingRequests.set(cacheKey, loadData(tagName, type));
    }

    try {
        const data = await pendingRequests.get(cacheKey);
        setCache(prev => ({ ...prev, [cacheKey]: data }));
        return data;
    } finally {
        pendingRequests.delete(cacheKey);
    }
};
